/* eslint-disable react-hooks/exhaustive-deps */
import { useContext, useEffect, useState } from 'react';
import { Table } from 'semantic-ui-react';
import { DisplayFromFHIR, AssociatedResourcesDisplay, SimpleResourceFieldViewer, getStringFromFHIR } from './ResourceFunctions';
import { MetadataPatternDisplay, DisplayClassifiers } from './MetadataPatternDisplay';
import FevirContext from './FevirContext';
import { EvidenceReportPackageSectionDisplay } from './EvidenceReportPackageViewingTool';
import { getResourceDictionary } from './ResourceDictionaryFunctions';
import { getIdFromReference } from './CompositionEvidenceTableAuthor';

const OutcomeMeasureEvidenceTableDisplay = ({ resourceDictionaryState }) => {
  const resultsSections = resourceDictionaryState.resultsSections;
  const groupReferencesDictionary = resourceDictionaryState.groupReferencesDictionary;
  const groupKeys = Object.keys(groupReferencesDictionary);
  const combinedDictionary = resourceDictionaryState.combinedDictionary;
  const evidenceDisplayDictionary = resourceDictionaryState.evidenceDisplayDictionary;
  const baselineDenomCountsSection = resourceDictionaryState.baselineDenomCountsSection;

  let countEvidenceForUnitsDictionary = null;
  if (baselineDenomCountsSection?.entry?.length > 0) {
    countEvidenceForUnitsDictionary = {};
    for (let entry of baselineDenomCountsSection.entry) {
      if (entry.reference[0] === "#") {
        let evidenceId = entry.reference.replace("#", "");
        let evidenceVariableReference = combinedDictionary[evidenceId].variableDefinition[0].observed.reference;
        let evidenceVariableId = evidenceVariableReference.replace("#", "");
        let groupReferenceId = combinedDictionary[evidenceVariableId]?.contained?.[2]?.id;
        if (groupReferenceId) {
          countEvidenceForUnitsDictionary[groupReferenceId] = entry; //"#" + 
        }
      }
    }
  }
  return <><Table>
    <Table.Header>
      <Table.Row>
        <Table.HeaderCell>Variable Name</Table.HeaderCell>
        {groupKeys.map((groupKey, groupIndex) => {
          return <Table.HeaderCell key={groupIndex}>{groupReferencesDictionary[groupKey].display}</Table.HeaderCell>
        })}
      </Table.Row>
    </Table.Header>
    <Table.Body>
      {countEvidenceForUnitsDictionary &&
        <Table.Row key="unit-counts">
          <Table.Cell style={{ verticalAlign: "top" }}>Number of units</Table.Cell>
          {groupKeys.map((groupKey, groupIndex) => {
            let unitReference = countEvidenceForUnitsDictionary[groupKey]?.reference.replace("#", "");
            return <Table.Cell key={groupIndex} style={{ verticalAlign: "top" }}>
              {countEvidenceForUnitsDictionary[groupKey] && <span>
                {(unitReference && evidenceDisplayDictionary[unitReference]) && evidenceDisplayDictionary[unitReference]}
              </span>}
            </Table.Cell>
          })}
        </Table.Row>}
      {resultsSections?.length && resultsSections.map((section, index) => {
        let evidenceForGroupDictionary = {};
        if (!section.entry || section.entry.length === 0) {
          return <Table.Row key={index}>
            <Table.Cell style={{ verticalAlign: "top" }}>
              {section.focus?.display || section.title}
            </Table.Cell>
            {groupKeys.map((groupKey, groupIndex) => {
              return <Table.Cell key={groupIndex} style={{ verticalAlign: "top" }}>
                <p>[No data.]</p>
              </Table.Cell>
            })}
          </Table.Row>
        }
        for (let entry of section.entry) {
          let evidenceId = getIdFromReference(entry);
          if (evidenceId && combinedDictionary[evidenceId]) {
            let groupReference = combinedDictionary[evidenceId].variableDefinition[0].observed || combinedDictionary[evidenceId].variableDefinition[0].intended;
            if (combinedDictionary[evidenceId].meta?.profile?.[0] === "http://hl7.org/fhir/uv/ebm/StructureDefinition/comparative-evidence") {
              groupReference = combinedDictionary[evidenceId].variableDefinition[1].observed || combinedDictionary[evidenceId].variableDefinition[1].intended;
            }
            let groupReferenceId = getIdFromReference(groupReference);
            evidenceForGroupDictionary[groupReferenceId] = evidenceId;
          }
        }

        return <Table.Row key={index}>
          <Table.Cell style={{ verticalAlign: "top" }}>
            {section.focus?.display || section.title}
          </Table.Cell>
          {groupKeys.map((groupKey, groupIndex) => {
            return <Table.Cell key={groupIndex} style={{ verticalAlign: "top" }}>
              {(evidenceForGroupDictionary[groupKey] &&
                evidenceDisplayDictionary[evidenceForGroupDictionary[groupKey]]
              ) && <span>
                  {evidenceDisplayDictionary[evidenceForGroupDictionary[groupKey]]}
                </span>}
            </Table.Cell>
          })}
        </Table.Row>
      })}
    </Table.Body>
  </Table></>
}

const addToEvidenceDisplayDictionary = (item, evidenceDisplayDictionary) => {
  let description = item.description;
  let statistics = item.statistic?.map(statistic => {
    let statisticDisplay = "";
    if (statistic.category) {
      let categoryDisplay = statistic.category.text || statistic.category.coding?.[0]?.display;
      statisticDisplay = "for " + categoryDisplay + ", "
    }
    if (statistic.sampleSize?.numberAnalyzed || statistic.sampleSize?.numberAnalyzed === 0) {
      statisticDisplay += "out of " + statistic.sampleSize.numberAnalyzed + ": ";
    } else if (statistic.sampleSize?.knownDataCount || statistic.sampleSize?.knownDataCount === 0) {
      statisticDisplay += "out of " + statistic.sampleSize.knownDataCount + ": ";
    } else if (statistic.sampleSize?.numberOfParticipants || statistic.sampleSize?.numberOfParticipants === 0) {
      statisticDisplay += "out of " + statistic.sampleSize.numberOfParticipants + ": ";
    }
    if (statistic.description) {
      statisticDisplay += statistic.description;
    } else {
      let statisticType = statistic.statisticType?.coding?.[0]?.display || statistic.statisticType?.text || "";
      let statisticQuantity = getStringFromFHIR.Quantity(statistic.quantity) || "";
      statisticDisplay += statisticType + " " + statisticQuantity;
      if (statistic.attributeEstimate?.length) {
        let attributeEstimatesDisplay = statistic.attributeEstimate.map(estimate => {
          let estimateDisplay = estimate.description || "";
          if (!estimateDisplay) {
            let estimateType = estimate.type?.coding?.[0]?.display || estimate.type?.text || "";
            let estimateQuantity = getStringFromFHIR.Quantity(estimate.quantity) || "";
            let estimateRange = getStringFromFHIR.Range(estimate.range) || "";
            if (estimate.level) {
              estimateDisplay = (100 * estimate.level).toString() + "% ";
            }
            estimateDisplay += estimateType + " " + estimateQuantity + estimateRange;
          }
          if (estimate.note?.length) {
            for (let note of estimate.note) {
              if (note.text) {
                estimateDisplay += "; " + note.text;
              }
            }
          }
          return estimateDisplay;
        }).join(", ");
        statisticDisplay += " (" + attributeEstimatesDisplay + ")";
      }
    }
    if (statistic.note?.length) {
      for (let note of statistic.note) {
        if (note.text) {
          statisticDisplay += "; " + note.text;
        }
      }
    }
    return statisticDisplay;
  }).join("; ");
  let notes = item.note?.map(note => note.text).join("; ");
  let evidenceDisplay = "";
  if (statistics) {
    evidenceDisplay = statistics;
  } else if (description) {
    evidenceDisplay = description;
  }
  if (notes) {
    if (evidenceDisplay) {
      evidenceDisplay += "; ";
    }
    evidenceDisplay += notes;
  }
  evidenceDisplayDictionary[item.id] = evidenceDisplay;
}

const loadResourceDictionary = async (fhirJson, globalContext, setResourceDictionaryState) => {
  let resourceDictionary = await getResourceDictionary(fhirJson, globalContext);
  let resultsSections = [];
  let additionalSections = [];
  let groupReferencesDictionary = {};
  let groupReferencesDefinedInGroupList = false;
  let baselineDenomCountsSection;
  let containedDictionary = {};
  let evidenceDisplayDictionary = {};
  let combinedDictionary = {};
  if (Array.isArray(fhirJson.section) && fhirJson.section.length > 0) {
    let tempSection = JSON.parse(JSON.stringify(fhirJson.section));
    for (const section of tempSection) {
      if (section?.code?.coding?.[0]?.code === "results") {
        resultsSections.push(section);
      } else if (section?.code?.text === "BaselineDenom") {
        baselineDenomCountsSection = section;
      } else if (section?.code?.text === "OutcomeGroupList" || section?.code?.text === "BaselineGroupList" ||
        section?.code?.text === "FlowGroupList" || section?.code?.text === "GroupList") {
        if (section.entry?.length) {
          for (let entry of section.entry) {
            let entryId = getIdFromReference(entry);
            if (!groupReferencesDictionary[entryId]) {
              groupReferencesDictionary[entryId] = entry;
            }
          }
        }
      } else {
        if (section?.section?.length > 0) {
          let additionalSubsections = [];
          let sectionFocus = section.focus;
          for (const subsection of section.section) {
            if (subsection?.code?.coding?.[0]?.code === "results") {
              if (!subsection.focus && sectionFocus) {
                subsection.focus = sectionFocus;
              }
              resultsSections.push(subsection);
            } else if (subsection?.code?.text === "OutcomeGroupList" || subsection?.code?.text === "BaselineGroupList" ||
              subsection?.code?.text === "FlowGroupList" || subsection?.code?.text === "GroupList") {
              if (subsection.entry?.length) {
                for (let entry of subsection.entry) {
                  let entryId = getIdFromReference(entry);
                  if (!groupReferencesDictionary[entryId]) {
                    groupReferencesDictionary[entryId] = entry;
                  }
                }
              }
            } else {
              if (subsection.focus) {
                sectionFocus = subsection.focus;
              }
              if (subsection?.section?.length > 0) {
                let additionalSubSubsections = [];
                for (const subsubsection of subsection.section) {
                  if (subsubsection?.code?.coding?.[0]?.code === "results") {
                    if (!subsubsection.focus && sectionFocus) {
                      subsubsection.focus = sectionFocus;
                    }
                    resultsSections.push(subsubsection);
                  } else {
                    additionalSubSubsections.push(subsubsection);
                  }
                }
                if (additionalSubSubsections.length > 0) {
                  subsection.section = additionalSubSubsections
                } else {
                  delete subsection.section;
                }
              }
              if (subsection?.section?.length || subsection?.entry ||
                (subsection?.text && subsection.text.div && subsection.text.status !== "empty")) {
                additionalSubsections.push(subsection);
              }
            }
          }
          if (additionalSubsections.length > 0) {
            section.section = additionalSubsections;
          } else {
            delete section.section;
          }
        }
        if (section?.section?.length || section?.entry ||
          (section?.text && section.text.div && section.text.status !== "empty")) {
          additionalSections.push(section);
        }
      }
    }
  }
  if (Object.keys(groupReferencesDictionary).length > 0) {
    groupReferencesDefinedInGroupList = true;
  }
  if (Array.isArray(fhirJson.contained) && fhirJson.contained.length > 0) {
    for (const item of fhirJson.contained) {
      containedDictionary[item.id] = item;
      if (item.resourceType === "Evidence") {
        addToEvidenceDisplayDictionary(item, evidenceDisplayDictionary);
        if (!groupReferencesDefinedInGroupList) {
          if (item.meta?.profile?.[0] === "http://hl7.org/fhir/uv/ebm/StructureDefinition/comparative-evidence" &&
            item.variableDefinition?.[1]?.variableRole === "exposure") {
            let entry = item.variableDefinition[1].observed || item.variableDefinition[1].intended;
            let entryId = getIdFromReference(entry);
            if (!groupReferencesDictionary[entryId]) {
              groupReferencesDictionary[entryId] = entry;
            }
          } else if (item.variableDefinition?.[0]?.variableRole === "population") {
            let entry = item.variableDefinition[0].observed || item.variableDefinition[0].intended;
            let entryId = getIdFromReference(entry);
            if (!groupReferencesDictionary[entryId]) {
              groupReferencesDictionary[entryId] = entry;
            }
          }
        }
      }
      combinedDictionary[item.id] = item;
    }
  }
  if (resourceDictionary && Object.keys(resourceDictionary).length) {
    for (const key of Object.keys(resourceDictionary)) {
      const item = resourceDictionary[key];
      if (item.resourceType === "Evidence") {
        addToEvidenceDisplayDictionary(item, evidenceDisplayDictionary);
        if (!groupReferencesDefinedInGroupList) {
          if (item.meta?.profile?.[0] === "http://hl7.org/fhir/uv/ebm/StructureDefinition/comparative-evidence" &&
            item.variableDefinition?.[1]?.variableRole === "exposure") {
            let entry = item.variableDefinition[1].observed || item.variableDefinition[1].intended;
            let entryId = getIdFromReference(entry);
            if (!groupReferencesDictionary[entryId]) {
              groupReferencesDictionary[entryId] = entry;
            }
          } else if (item.variableDefinition?.[0]?.variableRole === "population") {
            let entry = item.variableDefinition[0].observed || item.variableDefinition[0].intended;
            let entryId = getIdFromReference(entry);
            if (!groupReferencesDictionary[entryId]) {
              groupReferencesDictionary[entryId] = entry;
            }
          }
        }
      }
      combinedDictionary[key] = item;
    }
  }

  setResourceDictionaryState({
    "loaded": true,
    "resourceDictionary": resourceDictionary,
    "containedDictionary": containedDictionary,
    "combinedDictionary": combinedDictionary,
    "evidenceDisplayDictionary": evidenceDisplayDictionary,
    "resultsSections": resultsSections,
    "additionalSections": additionalSections,
    "groupReferencesDictionary": groupReferencesDictionary,
    "baselineDenomCountsSection": baselineDenomCountsSection
  });
}

const CompositionTableReportViewerTool = ({ fhirJson, classificationsArrayState,
  classificationsLoadedState }) => {

  const globalContext = useContext(FevirContext);
  const [resourceDictionaryState, setResourceDictionaryState] = useState({});

  useEffect(() => {
    loadResourceDictionary(fhirJson, globalContext, setResourceDictionaryState);
  }, []);

  let description;
  if (Array.isArray(fhirJson.extension) && fhirJson.extension.length > 0) {
    for (const extension of fhirJson.extension) {
      if (extension.url === 'http://hl7.org/fhir/StructureDefinition/artifact-description') {
        description = extension.valueMarkdown;
      }
    }
  }
  let howToCite;

  return <div>
    <div style={{ marginTop: "12px" }}>
      {description &&
        <div><b>Report Description: </b><DisplayFromFHIR markdown={description} />
        </div>}
      <p>
        <b>View PDF: </b>
        <a href={'https://computablepublishing.com/Composition/' + fhirJson.id}
          target='_blank' rel='noopener noreferrer'>View or download PDF</a>
      </p>
      <h3 id="evidence">Evidence</h3>
      {resourceDictionaryState.loaded && <OutcomeMeasureEvidenceTableDisplay resourceDictionaryState={resourceDictionaryState} />}
      <h3 id="discussion">Discussion</h3>
      {resourceDictionaryState?.additionalSections?.length ? <>
        {resourceDictionaryState.additionalSections.map((section, sectionIndex) => {
          return <div key={sectionIndex}>
            <EvidenceReportPackageSectionDisplay topSection={section} />
          </div>
        })}
      </>
        :
        <p>[No data other than the Evidence Table.]</p>}
      <br />
      <h3 id="how-to-cite">How to Cite</h3>
      <div style={{ marginLeft: "24px" }}>
        {(howToCite) ?
          <div>
            <p><b>Citation Summary:</b></p>
            <DisplayFromFHIR markdown={howToCite} />
          </div>
          :
          <p>Can be added upon editing.</p>
        }
      </div>
      <h3 id="metadata">Metadata</h3>
      <div style={{ marginLeft: "24px" }}>
        {Array.isArray(fhirJson.category) && fhirJson.category.length > 0 && <>
          {fhirJson.category.map((category, categoryIndex) => {
            return <span key={categoryIndex} >
              <b>Category: </b>
              <DisplayFromFHIR codeableConcept={category} />
            </span>
          })}
          <br /> <br />
        </>}
        {Array.isArray(fhirJson.subject) && fhirJson.subject.length > 0 && <>
          {fhirJson.subject.map((subject, subjectIndex) => {
            return <span key={subjectIndex} >
              <b>Subject: </b>
              <DisplayFromFHIR reference={subject} />
            </span>
          })}
          <br /> <br />
        </>}
        <MetadataPatternDisplay fhirJson={fhirJson} />
      </div>
      <h3 id="associated-resources">Associated Resources</h3>
      <div style={{ marginLeft: "24px" }}>
        <AssociatedResourcesDisplay fhirJson={fhirJson} />
      </div>
      <h3 id="classifiers">Classifiers</h3>
      {classificationsLoadedState ?
        <DisplayClassifiers classificationsArray={classificationsArrayState} />
        :
        <><img style={{ height: "22px" }} src="/spinner.gif" alt="Loading" /> Classifiers being loaded...</>
      }
      <h3 id="json-outline">JSON Outline</h3>
      <SimpleResourceFieldViewer resource={fhirJson} parentElement={""} />
      <br /><br />
    </div>
  </div>
}

export default CompositionTableReportViewerTool;
export { addToEvidenceDisplayDictionary };